export const AG_GRID_LOCALE_ES = {
  // General
  page: 'Página',
  more: 'Más',
  to: 'a',
  of: 'de',
  next: 'Siguiente',
  last: 'Último',
  first: 'Primero',
  previous: 'Anterior',
  loadingOoo: 'Cargando...',

  // Set Filter
  selectAll: 'Seleccionar todo',
  searchOoo: 'Buscar...',
  blanks: 'En blanco',

  // Number Filter & Text Filter
  filterOoo: 'Filtrar...',
  applyFilter: 'Aplicar filtro...',
  equals: 'Igual a',
  notEqual: 'No igual a',

  // Number Filter
  lessThan: 'Menor que',
  greaterThan: 'Mayor que',
  lessThanOrEqual: 'Menor o igual que',
  greaterThanOrEqual: 'Mayor o igual que',
  inRange: 'En rango',
  inRangeStart: 'Desde',
  inRangeEnd: 'Hasta',

  // Text Filter
  contains: 'Contiene',
  notContains: 'No contiene',
  startsWith: 'Comienza con',
  endsWith: 'Termina con',

  // Filter Conditions
  andCondition: 'Y',
  orCondition: 'O',

  // Grouping
  group: 'Grupo',
  rowGroupColumnsEmptyMessage: 'Arrastre aquí para agrupar por columnas',
  valueColumnsEmptyMessage: 'Arrastre aquí para agregar',

  // Pivoting
  pivotMode: 'Modo Pivote',
  pivotColumnsEmptyMessage: 'Arrastre aquí para establecer columnas pivote',

  // Tool Panel
  columns: 'Columnas',
  filters: 'Filtros',
  rowGroupColumns: 'Columnas de Agrupación',
  valueColumns: 'Columnas de Valores',
  pivotMode_part1: 'Modo Pivote',
  pivotMode_part2: 'Desactivado',
  toolPanelButton: 'Panel de Herramientas',

  // Other
  noRowsToShow: 'No hay filas para mostrar',
  pinColumn: 'Fijar Columna',
  valueAggregation: 'Agregar Valor',
  autosizeThiscolumn: 'Autoajustar esta Columna',
  autosizeAllColumns: 'Autoajustar todas las Columnas',
  groupBy: 'Agrupar por',
  ungroupBy: 'Desagrupar por',
  resetColumns: 'Reiniciar Columnas',
  expandAll: 'Expandir Todo',
  collapseAll: 'Contraer Todo',
  toolPanel: 'Panel de Herramientas',
  export: 'Exportar',
  csvExport: 'Exportar a CSV',
  excelExport: 'Exportar a Excel (.xlsx)',
  excelXmlExport: 'Exportar a Excel (.xml)',

  // Pinning
  pinLeft: 'Fijar a la Izquierda',
  pinRight: 'Fijar a la Derecha',
  noPin: 'No Fijar',

  // Aggregation
  sum: 'Suma',
  min: 'Mínimo',
  max: 'Máximo',
  none: 'Ninguno',
  count: 'Conteo',
  avg: 'Promedio',
  average: 'Promedio',
  filteredRows: 'Filas Filtradas',
  selectedRows: 'Filas Seleccionadas',
  totalRows: 'Filas Totales',
  totalAndFilteredRows: 'Filas',

  // Standard Menu
  copy: 'Copiar',
  copyWithHeaders: 'Copiar con Cabeceras',
  paste: 'Pegar',
};
